import React from 'react'
import { useTranslation } from 'react-i18next'

const DescriptionView = ({ setViewDesShowModal, description }) => {
  const { t } = useTranslation()
  function Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }


  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto mx-auto my-auto max-w-3xl max-h-3xl'>
          <form className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
              <div className='flex items-center justify-between py-2 px-3 border-b border-solid border-slate-200 rounded-t'>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setViewDesShowModal(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='mb-3 break-all'>
                  <div>{description}</div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default DescriptionView